export default {
    to: "/dashboard/team",
    order: 3,
    icon: "mdi-account-group",
    title: "Team",
    disabled: false,
    value: 0,
    sublinks: [],
}
